const autocompleteAddressFieldNames = (entity: string) => ({
    line1: `${entity}_autocomplete_address_line1`,
    line2: `${entity}_autocomplete_address_line2`,
    city: `${entity}_autocomplete_address_city`,
    state: `${entity}_autocomplete_address_state`,
    zipCode: `${entity}_autocomplete_address_zipCode`,
    country: `${entity}_autocomplete_address_country`,
});

export default autocompleteAddressFieldNames;